import { authService } from '@/services/auth-service';
import { navigate } from '@/utils/navigate';

class NuUserMenu extends HTMLElement {
  private readonly root: ShadowRoot;
  private _onDocClick = () => {
    this.root.querySelector<HTMLElement>('#dropdown')?.style.setProperty('display', 'none');
  };

  constructor() {
    super();
    this.root = this.attachShadow({ mode: 'open' });
  }

  connectedCallback() {
    if (!authService.isAuthenticated()) return;
    this._render();
    document.addEventListener('click', this._onDocClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this._onDocClick);
  }

  private _render() {
    this.root.innerHTML = `
      <style>
        :host { display: block; position: relative; }
        .icon-btn {
          display: flex; align-items: center; justify-content: center;
          width: 34px; height: 34px;
          background: transparent;
          border: 1px solid var(--line, #C9C0AC);
          border-radius: 50%;
          cursor: pointer;
          color: var(--ink, #2A2622);
          transition: background .15s;
          padding: 0;
        }
        .icon-btn:hover { background: var(--paper-light, #FAF7F0); }
        .dropdown {
          position: absolute;
          top: calc(100% + 8px);
          right: 0;
          min-width: 180px;
          background: var(--paper-light, #FAF7F0);
          border: 1px solid var(--line, #C9C0AC);
          border-radius: 6px;
          box-shadow: 0 4px 12px rgba(42,38,34,.12);
          overflow: hidden;
          z-index: 20;
        }
        .dropdown-name {
          padding: 12px 16px 10px;
          font-family: 'IBM Plex Mono', monospace;
          font-size: 13px; font-weight: 500;
          color: var(--ink, #2A2622);
          border-bottom: 1px solid var(--line, #C9C0AC);
        }
        .dropdown-item {
          display: block; width: 100%; padding: 10px 16px;
          background: transparent; border: none;
          font-family: 'Inter', sans-serif; font-size: 14px;
          color: var(--ink-soft, #5A5346); text-align: left;
          cursor: pointer; transition: background .12s;
        }
        .dropdown-item:hover { background: var(--paper, #E4DED2); }
      </style>
      <button class="icon-btn" id="user-btn" aria-label="User menu">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
          <circle cx="12" cy="7" r="4"/>
        </svg>
      </button>
      <div class="dropdown" id="dropdown" style="display:none">
        <div class="dropdown-name">${authService.getDisplayName()}</div>
        <button class="dropdown-item" id="logout-btn">Log out</button>
      </div>
    `;

    this.root.querySelector('#user-btn')!.addEventListener('click', (e) => {
      e.stopPropagation();
      const dd = this.root.querySelector<HTMLElement>('#dropdown')!;
      dd.style.display = dd.style.display !== 'none' ? 'none' : 'block';
    });

    this.root.querySelector('#dropdown')!.addEventListener('click', (e) => {
      e.stopPropagation();
    });

    this.root.querySelector('#logout-btn')!.addEventListener('click', async () => {
      await authService.logout();
      navigate('/app');
    });
  }
}

customElements.define('nu-user-menu', NuUserMenu);